export function formatMaintenanceEndTime(endTime?: string): { endDate: string; endTime: string } | undefined {
  if (!endTime) {
    return undefined;
  }

  const endTimeDate = new Date(endTime);
  if (Number.isNaN(endTimeDate.getTime())) {
    return undefined;
  }

  return {
    endDate: endTimeDate.toLocaleString(undefined, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }),
    endTime: endTimeDate.toLocaleString(undefined, {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
    }),
  };
}
